import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Logo } from "@/components/marketing/SiteNav";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export function useDemoLogin() {
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { setMe } = useAuth();
  const start = async () => {
    setBusy(true);
    try {
      const r = await api.post("/auth/demo");
      setMe(r.data);
      navigate("/app", { state: { user: r.data } });
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };
  return [busy, start];
}

export default function Login() {
  const { me } = useAuth();
  const [busy, startDemo] = useDemoLogin();
  useEffect(() => { document.title = "Sign in | Pulse Commissioning"; }, []);
  if (me) return <Navigate to="/app" replace />;

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid-bg flex items-center justify-center px-5">
      <div className="panel w-full max-w-md p-8 fade-up" data-testid="login-card">
        <Logo />
        <h1 className="text-3xl font-bold text-slate-50 mt-10">Sign in</h1>
        <p className="text-slate-400 text-sm mt-2">Use the Google account your organisation admin invited.</p>
        <button onClick={google} data-testid="login-google-btn" className="btn-accent w-full py-3.5 mt-8">Continue with Google</button>
        <div className="flex items-center gap-3 my-6 text-xs text-slate-500 font-mono"><span className="flex-1 h-px bg-[#1E2D4A]" />OR<span className="flex-1 h-px bg-[#1E2D4A]" /></div>
        <button onClick={startDemo} disabled={busy} data-testid="login-demo-btn" className="w-full py-3.5 border border-[#334155] text-slate-200 hover:border-amber-500 transition-colors flex items-center justify-center gap-2">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />}Try the demo (read-only)
        </button>
        <p className="text-xs text-slate-500 mt-6">No account yet? <a href="/#demo" className="text-amber-400 hover:underline">Request a demo</a> and we'll set up your organisation.</p>
      </div>
    </div>
  );
}
